import React, { useState } from "react";
import "./campaignDashBoard.css";
import CreateCampaignModal from "./createCampaignModal";
import PublishSuccessfulModal from "./publishSuccessfulModal";
import ViewCampaignModal from "./viewCampaign";
import EditCampaignModal from "./editCampaignModal";

export default function CampaignDashBoard() {
  const [createCampaignModal, setCreateCampaignModal] = useState(false);
  const [viewCampaignModal, setViewCampaignModal] = useState(false);
  const [publishSuccessModal, setPublishSuccessModal] = useState();
  const [editCampaignModal,setEditCampaignModal] = useState(false)
  return (
    <div className="campaign-management-content" style={{ marginTop: 55 }}>
      {/* This is the modal for the create campaign modal */}
      <CreateCampaignModal isOpen={createCampaignModal} setCreateCampaignModal={setCreateCampaignModal} />

      {/* This is the modal used for successful publishing */}
      {/* <PublishSuccessfulModal isOpen={true} /> */}

      {/* This is the modal used for view campaign */}
      <ViewCampaignModal isOpen={viewCampaignModal} setViewCampaignModal={setViewCampaignModal} />

      {/* This is the modal used for view campaign */}
      <EditCampaignModal isOpen={editCampaignModal} setEditCampaignModal={setEditCampaignModal} />

      <div className="content-header">
        <h1 className="page-title">Campaign Management (Promotional Banner)</h1>
        <button
          onClick={() => {
            setCreateCampaignModal(true);
          }}
          className="btn-create-campaign"
        >
          <span className="plus-icon">+</span> Create Campaign
        </button>
      </div>

      <div className="table-container">
        <table className="campaign-table">
          <thead>
            <tr>
              <th>Campaign Title</th>
              <th>Type</th>
              <th>Status</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Last Modified by</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td data-label="Campaign Title">Mid Year Promo</td>
              <td data-label="Type">Banner + Push</td>
              <td data-label="Status">Scheduled</td>
              <td data-label="Start Date">Sep 20</td>
              <td data-label="End Date">Sep 30</td>
              <td data-label="Last Modified by">Mowa Ijasanmi</td>
              <td data-label="Actions">
                <div className="action-buttons">
                  <button className="btn-view" onClick={(()=>{setViewCampaignModal(true)})}>View</button>
                  <button className="btn-edit"onClick={(()=>{setEditCampaignModal(true)})}>Edit</button>
                  <button className="btn-delete">Delete</button>
                </div>
              </td>
            </tr>
            <tr>
              <td data-label="Campaign Title">Mid Year Promo</td>
              <td data-label="Type">Banner + Push</td>
              <td data-label="Status">Scheduled</td>
              <td data-label="Start Date">Sep 20</td>
              <td data-label="End Date">Sep 30</td>
              <td data-label="Last Modified by">Mowa Ijasanmi</td>
              <td data-label="Actions">
                <div className="action-buttons">
                  <button className="btn-view">View</button>
                  <button className="btn-edit">Edit</button>
                  <button className="btn-delete">Delete</button>
                </div>
              </td>
            </tr>
            <tr>
              <td data-label="Campaign Title">Mid Year Promo</td>
              <td data-label="Type">Banner + Push</td>
              <td data-label="Status">Scheduled</td>
              <td data-label="Start Date">Sep 20</td>
              <td data-label="End Date">Sep 30</td>
              <td data-label="Last Modified by">Mowa Ijasanmi</td>
              <td data-label="Actions">
                <div className="action-buttons">
                  <button className="btn-view">View</button>
                  <button className="btn-edit">Edit</button>
                  <button className="btn-delete">Delete</button>
                </div>
              </td>
            </tr>
            <tr>
              <td data-label="Campaign Title">Mid Year Promo</td>
              <td data-label="Type">Banner + Push</td>
              <td data-label="Status">Scheduled</td>
              <td data-label="Start Date">Sep 20</td>
              <td data-label="End Date">Sep 30</td>
              <td data-label="Last Modified by">Mowa Ijasanmi</td>
              <td data-label="Actions">
                <div className="action-buttons">
                  <button className="btn-view">View</button>
                  <button className="btn-edit">Edit</button>
                  <button className="btn-delete">Delete</button>
                </div>
              </td>
            </tr>
            <tr>
              <td data-label="Campaign Title">Mid Year Promo</td>
              <td data-label="Type">Banner + Push</td>
              <td data-label="Status">Scheduled</td>
              <td data-label="Start Date">Sep 20</td>
              <td data-label="End Date">Sep 30</td>
              <td data-label="Last Modified by">Mowa Ijasanmi</td>
              <td data-label="Actions">
                <div className="action-buttons">
                  <button className="btn-view">View</button>
                  <button className="btn-edit">Edit</button>
                  <button className="btn-delete">Delete</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button className="page-btn active">1</button>
        <button className="page-btn">2</button>
        <button className="page-btn">3</button>
        <button className="page-btn">Next &gt;&gt;</button>
      </div>
    </div>
  );
}
